import React from "react";
import HomeSection1 from "./section1/HomeSection1";
import Homesection2 from "./section2/Homesection2";
import Homesection3 from "./section3/Homesection3";
import Homesection4 from "./section4/Homesection4";
import AffiliationSection5 from "./section5/AffiliationSection5";
// import kanak from '../../images/homeimage/innerimg.jpg'
// import HomeSection1Card from "./section1/HomeSection1Card";
const Home = () => {
  return (
    <div className="w-screen overflow-x-hidden">
      <div className="">
        <div className="parallax bg-[url(https://images.unsplash.com/photo-1581078426770-6d336e5de7bf?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTZ8fGVkdWNhdGlvbnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60)] bg-cover bg-fixed bg-no-repeat">
          <div className="">
            <div className="row align-items-center justify-content-center">
              <div className="col-12">
                <div className="row justify-content-left">
                  <div className="col-lg-6 align-self-center order-lg-2 text-center">
                    <a
                      href="https://vimeo.com/342333493"
                      data-fancybox=""
                      className="video-play-btn aos-init aos-animate"
                      data-aos="fade-up"
                      data-aos-delay="400"
                    >
                      <span className="icon-play"></span>
                    </a>
                  </div>
                  <div className="p-60 px-2 text-center lg:w-[80%] lg:mx-auto ">
                    <div>
                      <img src="" alt="" />
                      <h1 class="text-center text-white  text-6xl font-bold lg:text-9xl">
                        S.S. PUBLIC SCHOOL , AGRA
                      </h1>
                    </div>

                    <div className="mt-20  bg-black opacity-70 lg:py-10">
                      <h1 className="font-serif lg:text-6xl  text-3xl text-white ">
                        Learning Center for Your Kids
                      </h1>
                      <div className="lg:p-9 p-3 lg:text-4xl text-white">
                        <p className="">
                          Stay positive, work hard, and success will be knocking
                          on your door. Have faith in yourself because I have
                          faith in you. Good luck to you. Everything seems
                          impossible until it is done.
                          <br />
                        </p>
                        <h1 className="text-blue-700 py-3 ">
                          {" "}
                          Nothing is impossible || Knowledge is power || Good
                          things, take time
                        </h1>
                      </div>
                      {/* <button className="h-14 w-48 rounded-md bg-blue-700 text-2xl text-white">
                      Explore Now
                    </button> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-----------------box------------------------------> */}
      </div>
      <div className="lg:w-[95%] lg:mx-auto ">
        <HomeSection1 />
      </div>

      <Homesection2 />
      <AffiliationSection5 />
      <Homesection3 />
      <Homesection4 />
    </div>
  );
};

export default Home;
// ab dusra section bna folder bna section2 usme main file bna section2 naam jo bhi uske andar section2 daal usme agr card copy ho rhe h toh unka componen bna le
// dekh kya bnaya h tune section2 m
